<!--

A dropdown to select one or more countries by code.

-->

<template>
  <v-menu
    v-model="showMenu"
    offset-y
    bottom
    right
    class="ml-1"
    :disabled="disabled"
    :close-on-content-click="false"
  >
    <v-btn
      slot="activator"
      icon
      class="ma-0"
    >
      <v-icon
        :class="{
          'grey--text text--darken-1': !active,
          'msr--text': active,
        }"
      >
        language
      </v-icon>
    </v-btn>
    <v-list class="pb-0">
      <v-list-tile>
        <v-checkbox
          :input-value="allSelected"
          :label="$t('allCapitalized')"
          color="msr"
          @change="toggleAllSelected"
        />
      </v-list-tile>
      <v-divider />
    </v-list>
    <v-list style="max-height: 300px; overflow: auto">
      <!-- Checkboxes -->
      <v-list-tile
        v-for="country in orderedCountryObjects"
        :key="country.code"
        class="list-tile-auto-height"
        style="height: 32px"
      >
        <v-layout align-center>
          <v-checkbox
            :label="country.name"
            :input-value="isCountrySelected(country.code)"
            hide-details
            class="mt-0"
            color="msr"
            @change="onCountrySelected(country.code, $event)"
          />
        </v-layout>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import orderBy from 'lodash.orderby';

export default {
  props: {
    /**
     * An object mapping countrycode to country name.
     */
    countries: {
      type: Object,
      required: true,
    },
    /** Add v-model support. Use from outside like: v-model="..." */
    value: {
      type: Array[String],
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      busy: false,
      showMenu: false,
    };
  },
  computed: {
    orderedCountryObjects() {
      const countryObjects = Object.keys(this.countries).map((code) => {
        const name = this.countries[code];
        return {
          code: code,
          name: name,
        };
      });
      return orderBy(countryObjects, 'name');
    },
    countryCodes() {
      return Object.keys(this.countries);
    },
    /** Implement the v-model handlers. */
    selectedCountryCodes: {
      get() {
        return this.value;
      },
      set(codes) {
        this.$emit('input', codes);
      },
    },
    allSelected() {
      return this.selectedCountryCodes.length === this.countryCodes.length;
    },
  },
  methods: {
    toggleAllSelected(v) {
      if (this.allSelected) {
        this.selectedCountryCodes = [];
      } else {
        this.selectedCountryCodes = this.countryCodes;
      }
    },
    isCountrySelected(code) {
      return this.selectedCountryCodes.indexOf(code) !== -1;
    },
    onCountrySelected(code, selected) {
      if (selected) {
        // Add code to list.
        if (this.isCountrySelected(code)) {
          return;
        }

        const newCodes = this.selectedCountryCodes.slice();
        newCodes.push(code);
        this.selectedCountryCodes = newCodes;
      } else {
        // Remove code from list.
        const index = this.selectedCountryCodes.indexOf(code);
        const notContained = index === -1;
        if (notContained) {
          return;
        }

        const newCodes = this.selectedCountryCodes.slice();
        newCodes.splice(index, 1);
        this.selectedCountryCodes = newCodes;
      }
    },
  },
};
</script>

<style scoped>
.no-padding >>> .v-list__tile {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/CountryFilterMenu.vue